import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { scrollToId } from "@/lib/api";
import { IMG } from "@/lib/assets";

const CATEGORIES = [
  "VUS",
  "Berlines",
  "Camions",
  "Véhicules de luxe",
  "Véhicules sportifs",
  "Véhicules familiaux",
  "Véhicules économiques",
  "Véhicules commerciaux",
];

export default function Inventory() {
  return (
    <section id="inventaire" data-testid="inventory-section" className="py-24 md:py-32 lg:py-36 relative overflow-hidden">
      <div className="container-x">
        <div className="relative rounded-3xl overflow-hidden border border-white/10">
          <img
            src={IMG.silhouette}
            alt="Silhouette d'un véhicule sportif haute performance en studio"
            className="absolute inset-0 w-full h-full object-cover"
            loading="lazy"
          />
          <div className="absolute inset-0 bg-ink/80" />
          <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/70 to-transparent" />

          <div className="relative z-10 p-8 sm:p-14 lg:p-20 max-w-3xl">
            <Reveal>
              <span className="overline-tag">Notre réseau, pas notre lot</span>
              <div className="mt-6 flex items-baseline gap-4">
                <span data-testid="inventory-count" className="font-mono text-6xl sm:text-7xl lg:text-8xl gold-text leading-none">
                  600+
                </span>
                <span className="font-display text-2xl sm:text-3xl text-white">véhicules d'occasion</span>
              </div>
              <p className="mt-6 text-sm sm:text-base text-slate-300 font-light leading-relaxed max-w-xl">
                Nous ne possédons aucun inventaire sur place : nous travaillons avec un réseau de garages
                et de concessionnaires déjà établis. L'offre est bien trop vaste pour tout afficher ici —
                alors plutôt que de fouiller des centaines d'annonces, décrivez-nous votre véhicule idéal
                et recevez une sélection personnalisée, déjà filtrée et vérifiée.
              </p>
            </Reveal>

            <Reveal delay={0.12}>
              <div className="mt-9 flex flex-wrap gap-2.5" data-testid="inventory-categories">
                {CATEGORIES.map((c) => (
                  <span
                    key={c}
                    className="text-[11px] sm:text-xs uppercase tracking-[0.15em] text-slate-200 border border-white/20 bg-white/5 backdrop-blur-sm rounded-full px-4 py-2 hover:border-gold/50 hover:text-gold-light transition-colors duration-300"
                  >
                    {c}
                  </span>
                ))}
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <button
                data-testid="inventory-cta-view-vehicles"
                onClick={() => scrollToId("#recherche")}
                className="btn-gold mt-10"
              >
                Recevoir une sélection personnalisée <ArrowRight size={16} />
              </button>
              <p className="mt-4 text-xs text-slate-500 font-light">
                Réponse de notre équipe sous 24 h — avec des véhicules réellement disponibles dans le
                réseau.
              </p>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
